module.exports = __webpack_public_path__ + "static/media/optima-seguros-thumbs.b3292b42.svg";